import { KiteGrid, KiteGridCell } from '@kite/react-kite';
import React from 'react';
import { Eyebrow } from '../Eyebrow/Eyebrow';
import './SmallLeadershipGrid.scss';

export const SmallLeadershipGrid = ({ node }) => {
    return (
        <section className="paragraph__ld-grid kite-container">
            <Eyebrow text={node.field_eyebrow_text} bg="light" />
            <h2>{node.field_overviewblock3title}</h2>
            <KiteGrid>
                <KiteGridCell col={6}>
                    <section className="ld-card">
                        <h3>
                            {
                                node.relationships.field_overvieblockleadership
                                    ?.field_leadership
                            }
                        </h3>
                        <h4>
                            {
                                node.relationships.field_overvieblockleadership
                                    ?.field_leadership_position_title
                            }
                        </h4>
                        <a
                            href={
                                node.relationships.field_overvieblockleadership
                                    ?.fields?.url
                            }
                        >
                            View Biography
                        </a>
                    </section>
                </KiteGridCell>
                <KiteGridCell col={6} className="small-cards">
                    {node.relationships.field_overvieblockleadershiprigh?.map(
                        (leader) => (
                            <section className="ld-card" key={leader.id}>
                                <h3>{leader.field_leadership}</h3>
                                <h4>
                                    {leader.field_leadership_position_title}
                                </h4>
                            </section>
                        )
                    )}
                </KiteGridCell>
            </KiteGrid>
        </section>
    );
};
